let triggerBtn, modal, declineBtn, acceptBtn;
let isInitialized = false;

const variantMappings = {
  44355298984086: 44355301703830,
  44355299016854: 44355301736598,
  44355298918550: 44355301638294,
  44355298951318: 44355301671062,
  44355298885782: 44355301605526,
  44355298820246: 44355301539990,
  44355298853014: 44355301572758,
  44355300130966: 44355302850710,
  44355300163734: 44355302883478,
  44355300065430: 44355302785174,
  44355300098198: 44355302817942,
  44355299278998: 44355301998742,
  44998743851158: 44998775079062,
  44355299377302: 44355302097046,
  44355299475606: 44355302195350,
  44355299508374: 44355302228118,
  44355299770518: 44355302490262,
  44355299672214: 44355302391958,
  44355299704982: 44355302424726,
  44355299803286: 44355302523030,
  44355299573910: 44355302293654,
  44355299901590: 44355302621334,
  44355299606678: 44355302326422,
  44355299115158: 44355301834902,
  44355299147926: 44355301867670,
  44355299180694: 44355301900438,
  44355299049622: 44355301769366,
  44355299082390: 44355301802134,
  44355299999894: 44355302719638,
  44355300032662: 44355302752406,
  44355299934358: 44355302654102,
  44355299967126: 44355302686870,
  44355299410070: 44355302129814,
  44355299311766: 44355302031510,
  44355299344534: 44355302064278,
  44355299442838: 44355302162582,
  44355299213462: 44355301933206,
  44355299246230: 44355301965974,
  44355299737750: 44355302457494,
  44355299836054: 44355302555798,
  44355299868822: 44355302588566,
  44355299541142: 44355302260886,
};

async function checkVariantAvailability(upgradedVariantId) {
  try {
    const response = await fetch(`/products/miracle-sheet-set-extra-luxe.js`);
    if (!response.ok) throw new Error("Failed to fetch product");

    const product = await response.json();
    const variant = product.variants.find(
      (v) => v.id.toString() === upgradedVariantId.toString(),
    );

    if (!variant) {
      return { available: false, inventory_quantity: 0 };
    }

    return {
      available: variant.available === true,
      inventory_quantity: variant.inventory_quantity || 0,
    };
  } catch (error) {
    console.error(`Error checking availability:`, error);
    return { available: false, inventory_quantity: 0 };
  }
}

function initializeUpsellModal() {
  cleanupUpsellModal();

  triggerBtn = document.querySelector(".custom-pre-checkout");
  modal = document.getElementById("preCheckoutModal");
  declineBtn = document.getElementById("declineUpsell");
  acceptBtn = document.getElementById("acceptUpsell");

  if (!triggerBtn || !modal) {
    return;
  }

  triggerBtn.addEventListener("click", handleTriggerClick);
  if (declineBtn) declineBtn.addEventListener("click", handleDeclineClick);
  if (acceptBtn) acceptBtn.addEventListener("click", handleAcceptClick);

  isInitialized = true;
}

function cleanupUpsellModal() {
  if (triggerBtn && isInitialized) {
    triggerBtn.removeEventListener("click", handleTriggerClick);
  }
  if (declineBtn && isInitialized) {
    declineBtn.removeEventListener("click", handleDeclineClick);
  }
  if (acceptBtn && isInitialized) {
    acceptBtn.removeEventListener("click", handleAcceptClick);
  }
  isInitialized = false;
}

async function handleTriggerClick(e) {
  e.preventDefault();
  e.stopPropagation();

  try {
    const cart = await getCart();

    let hasAvailableUpgrade = false;
    const availableUpgrades = [];

    for (const item of cart.items) {
      const originalVariantId = item.variant_id.toString();
      const upgradedVariantId = variantMappings[originalVariantId];

      if (upgradedVariantId) {
        const availability = await checkVariantAvailability(upgradedVariantId);

        if (availability.available && availability.inventory_quantity > 0) {
          hasAvailableUpgrade = true;
          availableUpgrades.push({
            originalVariantId,
            upgradedVariantId,
            requestedQuantity: item.quantity,
            availableQuantity: availability.inventory_quantity,
            cartItemKey: item.key || item.id,
          });
        }
      }
    }

    const currentModal = document.getElementById("preCheckoutModal");

    if (hasAvailableUpgrade && availableUpgrades.length > 0) {
      currentModal.dataset.upgradeInfo = JSON.stringify(availableUpgrades);
      currentModal.classList.add("active");
      document.body.style.overflow = "hidden";
    } else {
      window.location.href = "/checkout";
    }
  } catch (error) {
    console.error("Error in handleTriggerClick:", error);
    const currentModal = document.getElementById("preCheckoutModal");
    if (currentModal) {
      currentModal.classList.add("active");
      document.body.style.overflow = "hidden";
    }
  }
}

function handleDeclineClick() {
  const currentModal = document.getElementById("preCheckoutModal");
  if (currentModal) {
    currentModal.classList.remove("active");
    document.body.style.overflow = "";
  }
  window.location.href = "/checkout";
}

async function handleAcceptClick() {
  if (!acceptBtn) return;

  const originalText = acceptBtn.textContent;
  acceptBtn.disabled = true;
  acceptBtn.textContent = "Upgrading...";

  try {
    const currentModal = document.getElementById("preCheckoutModal");
    const cart = await getCart();

    const itemsToUpdate = {};
    const itemsToAdd = [];

    let upgradeInfo = [];
    if (currentModal.dataset.upgradeInfo) {
      upgradeInfo = JSON.parse(currentModal.dataset.upgradeInfo);
    }

    if (upgradeInfo.length === 0) {
      for (const item of cart.items) {
        const originalVariantId = item.variant_id.toString();
        const upgradedVariantId = variantMappings[originalVariantId];

        if (upgradedVariantId) {
          const availability =
            await checkVariantAvailability(upgradedVariantId);

          if (availability.available && availability.inventory_quantity > 0) {
            upgradeInfo.push({
              originalVariantId,
              upgradedVariantId,
              requestedQuantity: item.quantity,
              availableQuantity: availability.inventory_quantity,
              cartItemKey: item.key || item.id,
            });
          }
        }
      }
    }

    // Build the list of upgraded line items per original cart line so we can
    // preserve free-gift pairing properties (_pairId / _hasFreeGift) on a
    // per-line basis instead of aggregating by variant id.
    for (const info of upgradeInfo) {
      const cartItem = cart.items.find(
        (item) =>
          (item.key || item.id).toString() === info.cartItemKey?.toString() ||
          item.variant_id.toString() === info.originalVariantId.toString(),
      );

      if (!cartItem) continue;

      const itemKey = cartItem.key || cartItem.id;
      const requestedQty = info.requestedQuantity || cartItem.quantity;
      const availableQty = info.availableQuantity;
      const quantityToUpgrade = Math.min(requestedQty, availableQty);

      if (quantityToUpgrade <= 0) continue;

      const remainingOriginalQty = requestedQty - quantityToUpgrade;
      // 0 = remove original line; >0 = keep some remaining quantity
      itemsToUpdate[itemKey] = remainingOriginalQty;

      const origProps = cartItem.properties || {};
      const origPairId = origProps._pairId || null;
      const origHasFreeGift =
        origProps._hasFreeGift === "true" || origProps._hasFreeGift === true;

      const addItem = {
        id: parseInt(info.upgradedVariantId),
        quantity: quantityToUpgrade,
      };

      // Transfer the gift pairing onto the upgraded line so the cart drawer
      // continues to sync inc/dec/remove between the upgraded product and
      // its existing free gift. Only do this on a full upgrade — for a
      // partial upgrade, the original line stays and remains the gift's
      // anchor via its own _pairId; the upgraded line is added unpaired
      // to avoid the gift quantity being incorrectly overwritten.
      if (origHasFreeGift && origPairId && remainingOriginalQty === 0) {
        addItem.properties = {
          _hasFreeGift: "true",
          _pairId: origPairId,
        };
      }

      itemsToAdd.push(addItem);
    }

    if (itemsToAdd.length === 0) {
      if (currentModal) {
        currentModal.classList.remove("active");
        document.body.style.overflow = "";
      }
      window.location.href = "/checkout";
      return;
    }

    // Update cart with the adjusted quantities (sets originals to 0 or to
    // the leftover quantity for partial upgrades).
    if (Object.keys(itemsToUpdate).length > 0) {
      await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ updates: itemsToUpdate }),
      });
    }

    // Add upgraded items in a single call using the items[] form so
    // line-item properties (the gift _pairId) are preserved per item.
    await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: itemsToAdd }),
    });

    await refreshCartDrawer();

    if (currentModal) {
      currentModal.classList.remove("active");
      document.body.style.overflow = "";
    }

    setTimeout(() => {
      proceedToCheckout();
    }, 500);
  } catch (error) {
    console.error("Error during upsell processing:", error);
    window.location.href = "/checkout";
  } finally {
    if (acceptBtn) {
      acceptBtn.disabled = false;
      acceptBtn.textContent = originalText;
    }
  }
}

async function refreshCartDrawer() {
  const cartDrawer = document.querySelector("cart-drawer");
  if (!cartDrawer) return;

  try {
    if (typeof cartDrawer.renderContents === "function") {
      const cartResponse = await fetch("/cart.js");
      const cartData = await cartResponse.json();
      const sectionsResponse = await fetch(
        "/?sections=cart-drawer,cart-icon-bubble,cart-items",
      );
      const sectionsData = await sectionsResponse.json();

      const parsedState = {
        items: cartData.items,
        item_count: cartData.item_count,
        total_price: cartData.total_price,
        original_total_price:
          cartData.original_total_price || cartData.total_price,
        sections: sectionsData,
      };

      try {
        cartDrawer.renderContents(parsedState);
      } catch {
        cartDrawer.renderContents(sectionsData);
      }
    }
  } catch (error) {
    console.error("Error refreshing cart drawer:", error);
  }
}

function proceedToCheckout() {
  const checkoutSelectors = [
    "#CartDrawer-Checkout",
    '[name="checkout"]',
    '[href*="/checkout"]',
    ".cart__checkout",
    'button[type="submit"][name="checkout"]',
  ];

  for (const selector of checkoutSelectors) {
    const checkoutBtn = document.querySelector(selector);
    if (checkoutBtn) {
      checkoutBtn.click();
      return;
    }
  }

  window.location.href = "/checkout";
}

async function getCart() {
  const response = await fetch("/cart.js");
  if (!response.ok) throw new Error("Failed to fetch cart");
  return await response.json();
}

document.addEventListener("DOMContentLoaded", function () {
  initializeUpsellModal();

  document.addEventListener("click", function (e) {
    const btn = e.target.closest(".custom-pre-checkout");
    if (btn) {
      e.preventDefault();
      e.stopPropagation();

      if (!isInitialized) {
        initializeUpsellModal();
      }

      handleTriggerClick(e);
    }
  });
});

const checkoutObserver = new MutationObserver(function (mutations) {
  for (const mutation of mutations) {
    if (mutation.type === "childList") {
      for (const node of mutation.addedNodes) {
        if (node.nodeType === Node.ELEMENT_NODE) {
          if (
            node.matches &&
            (node.matches(".custom-pre-checkout") ||
              node.matches("#preCheckoutModal"))
          ) {
            initializeUpsellModal();
            return;
          }
          if (node.querySelector) {
            if (
              node.querySelector(".custom-pre-checkout") ||
              node.querySelector("#preCheckoutModal")
            ) {
              initializeUpsellModal();
              return;
            }
          }
        }
      }
    }
  }
});

checkoutObserver.observe(document.body, {
  childList: true,
  subtree: true,
});

document.addEventListener("cart:updated", initializeUpsellModal);
document.addEventListener("cart:refresh", initializeUpsellModal);
window.addEventListener("pageshow", initializeUpsellModal);
